<script setup lang="ts">
import { ScrollArea } from '@/components/ui/scroll-area';

export interface HeadingItem {
    level: number;
    text: string;
    pos: number;
}

defineProps<{
    headings: HeadingItem[];
}>();

const emit = defineEmits<{
    jump: [pos: number];
}>();
</script>

<template>
    <aside
        class="flex min-h-0 flex-col border-r border-border/40 bg-background"
    >
        <div
            class="px-4 pt-4 pb-2 text-[10px] font-semibold tracking-wider text-muted-foreground uppercase"
        >
            Plan du document
        </div>

        <ScrollArea class="flex-1 pb-4">
            <ul v-if="headings.length" class="space-y-0.5 px-2">
                <li v-for="item in headings" :key="item.pos">
                    <button
                        type="button"
                        :class="[
                            'w-full rounded px-2 py-1 text-left text-xs transition hover:bg-muted',
                            item.level === 2
                                ? 'font-medium text-foreground'
                                : 'pl-5 text-muted-foreground',
                        ]"
                        @click="emit('jump', item.pos)"
                    >
                        {{ item.text }}
                    </button>
                </li>
            </ul>

            <p v-else class="px-4 py-3 text-xs text-muted-foreground italic">
                Ajoutez des titres pour voir le plan apparaître ici.
            </p>
        </ScrollArea>
    </aside>
</template>
